import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-initialized',
  templateUrl: './initialized.component.html',
  styleUrl: './initialized.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InitializedComponent {
  @Input() createdDate?: string | Date;
  @Input() createdBy;
  @Input() environmentName;
  @Input() serviceDefinitionVersion;
  @Input() deploymentClass;
  @Input() dataZone;
  @Input() releaseVersion;
  @Input() requestOrigination;
  @Input() contractEndDate;
  @Input() environment;
  @Input() service;
  @Input() region;
  isDateLoading = true;

  ngOnChanges(): void {
  if (this.createdDate) {
    this.isDateLoading = false;
  }
}

private formatDate(date?: string | Date): string {
  if (!date) {
    return '-';
  }

  return new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  }).replace(' ', ' ');
}

  get formattedDate(): string {
    return this.formatDate(this.createdDate);
  }

}
